import React from 'react';

import { Container } from './styles';

const ActivityIndicator: React.FC = () => <Container />;

export default ActivityIndicator;
